// Notificações do sistema (Pomodoro: fim do bloco e "Voltar ao foco").
// Desktop: plugin de notificação do Tauri. Web: Notification API, se o usuário permitir.
import type { DesktopBridge } from './desktop';

export type Notifier = (title: string, body: string) => Promise<void>;

export function createNotifier(desktop: DesktopBridge | null): Notifier {
  return async (title, body) => {
    if (desktop) return desktop.notify(title, body);
    const N = (globalThis as { Notification?: typeof Notification }).Notification;
    if (!N) return;
    try {
      if (N.permission === 'default') await N.requestPermission();
      if (N.permission === 'granted') new N(title, { body, icon: '/favicon.svg' });
    } catch {
      /* sem permissão: o aviso aparece só dentro do app */
    }
  };
}
